import ConditionType from './ConditionType'

const GreaterThanCondition: ConditionType = {
  value: 'greater than',
  label: 'Greater Than',
  hasRHS: true,
}

export default GreaterThanCondition
